import { Modal, UI, Utils } from 'common';
import moment from 'moment';
import React, { useContext } from 'react';
import MailInRefundForm from '../refund/MailInRefundForm.component';
import RefundDetailsModal from '../refund/RefundDetailsModal.component';
import { RefundType } from '../shared/RefundTypeOptions';
import { DataDisplayPanel } from './DataDisplayPanel.component';

const { ModalContext } = Modal;
const { WrappedButton, WrappedTooltip, WrappedButtonType } = UI;
const { Util, Session } = Utils;

const CreditedAmountTemplate = ({
	refundApprovedAmount,
	refundassistRefundPercent,
}) => (
	<>
		<div className="credited-amount-section">
			{Util.formatCurrency(refundApprovedAmount)}{' '}
			<span className="credited-amount-icon credited-amount-info" />
			<WrappedTooltip
				target="credited-amount-info"
				position="top"
				tooltip={`With Refund Assist, the amount credited to your balance is ${refundassistRefundPercent}% of the refunded amount.`}
			/>{' '}
		</div>
	</>
);

const RefundPanel = ({ printDetails, labelAndOrderDetails }) => {
	const {
		refundType = '',
		refundStatus = '',
		refundRequestedDate,
		refundEstimatedCloseDate,
		refundApprovedAmount,
		refundTypeName = '',
		isRefundAssist,
	} = printDetails;
	const { labelDetails = {} } = labelAndOrderDetails;
	const { refunds = [] } = labelDetails;
	const { showModal } = useContext(ModalContext);
	const { refundassistRefundPercent = 0 } = Session.getAccountInfo();

	const refundDataDisplay = [
		{
			body: refundStatus,
			dataqa: 'refund-status',
			label: 'Refund Status:',
		},
		{
			body: moment(refundRequestedDate).format('MM/DD/YYYY'),
			dataqa: 'refund-request-date',
			label: 'Request Date:',
		},
		{
			body: moment(refundEstimatedCloseDate).format('MM/DD/YYYY'),
			dataqa: 'est-close-date',
			label: 'Est. Close Date:',
		},
		{
			body:
				refunds[0].refundType === RefundType.MailIn
					? refunds[0].refundMailinBatchid.toString()
					: refunds[0].refundId.toString(),
			dataqa: 'claim-number',
			label: 'Claim Number:',
		},
		{
			body:
				refundApprovedAmount && isRefundAssist ? (
					<CreditedAmountTemplate
						refundApprovedAmount={refundApprovedAmount}
						refundassistRefundPercent={refundassistRefundPercent}
					/>
				) : (
					''
				),
			dataqa: 'credited-amount',
			label: 'Credited Amount:',
		},
		{
			body:
				refundApprovedAmount && !isRefundAssist
					? Util.formatCurrency(refundApprovedAmount)
					: '',
			dataqa: 'refund-approved-amount',
			label: 'Refund Amount:',
		},
		{
			body: `${isRefundAssist ? 'Refund Assist' : refundTypeName}`,
			dataqa: 'refund-type-name',
			label: 'Refund Type:',
		},
	];

	const onClickViewRefundDetailButton = () => {
		showModal({
			component: RefundDetailsModal,
			data: {
				selectedPrints: refunds,
			},
		});
	};

	const onClickReprintClaimFormButton = () => {
		showModal({
			component: MailInRefundForm,
			data: {
				formData: labelDetails,
				printDetails,
			},
		});
	};

	return (
		<div className="refund-panel">
			{refundDataDisplay.map(
				(refund, i) =>
					refund.body && (
						<DataDisplayPanel
							label={refund.label}
							body={refund.body}
							dataqa={refund.dataqa}
							key={`${refund.dataqa}_${i}`}
						/>
					)
			)}
			<hr />
			<div className="p-grid p-nogutter action-row">
				<WrappedButton
					label="Reprint Claim Form"
					className="reprint-claim-form-button"
					dataqa="reprint-claim-form-grid-btn"
					disabled={refundType !== RefundType.MailIn}
					buttonType={WrappedButtonType.TertiaryGrey}
					icon={null}
					onClick={onClickReprintClaimFormButton}
					position="bottom"
				/>
				<WrappedButton
					label="View Refund Details"
					className="view-refund-details-button"
					dataqa="view-refund-details-grid-btn"
					buttonType={WrappedButtonType.TertiaryGrey}
					icon={null}
					onClick={onClickViewRefundDetailButton}
				/>

				<WrappedTooltip
					tooltip="View Refund Details"
					target="view-refund-details-button"
					position="bottom"
				/>
			</div>
		</div>
	);
};

export default RefundPanel;
